// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2d6c3128","239":"a5802fc1","455":"949a080e"}[chunkId] + ".chunk.js";
};